import { Fragment, useState } from 'react';

import { Tab, Transition } from '@headlessui/react';
import Autoplay from 'embla-carousel-autoplay';

import { type ProductVariantCardFragment } from '@boc/framework/saleor-graphql';

import { buttonVariants } from '~/local/components/button';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNavigation,
} from '~/local/homepage/components/slider';
import VariantCard from '~/local/products/components/variant-card';

export default function ProductTabs({
  products,
}: {
  products: { name: string; products: ProductVariantCardFragment[] }[];
}) {
  const [selectedIndex, setSelectedIndex] = useState(2);

  return (
    <Tab.Group as={'div'} selectedIndex={selectedIndex} onChange={setSelectedIndex}>
      <Tab.List>
        <div className="border-b-neutral-2-20 gap-y-2 border-b pb-12 ease-in-out md:flex">
          {products.map((mapping) => {
            return (
              <Tab key={mapping.name} as={Fragment}>
                <button className={`${buttonVariants({ intent: 'filter' })} m-1`}>
                  {mapping.name}
                </button>
              </Tab>
            );
          })}
        </div>
      </Tab.List>
      <Tab.Panels className={'pt-9'}>
        {products.map((mapping, index) => {
          return (
            <Tab.Panel key={mapping.name}>
              <Transition
                appear
                show={selectedIndex == index}
                enter="transition-opacity ease-in-out duration-1000"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-in-out duration-1000"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Carousel
                  plugins={[
                    Autoplay({
                      delay: 2500,
                    }),
                  ]}
                >
                  <CarouselContent>
                    {mapping.products.map((variant, index) => {
                      return (
                        <CarouselItem key={index} className="basis-1/2 md:basis-1/4">
                          <VariantCard
                            showDiscount={true}
                            key={`${mapping.name}-variants-${variant.id}`}
                            variant={variant}
                          />
                        </CarouselItem>
                      );
                    })}
                  </CarouselContent>
                  <CarouselNavigation />
                </Carousel>
              </Transition>
            </Tab.Panel>
          );
        })}
      </Tab.Panels>
    </Tab.Group>
  );
}
